import { featureFlagKey } from "@redotech/feature-flags-model/keys";

export const MarketingFlagKey = {
  ORDER_TRACKING_ANOMALY_DETECTION_HOURS: featureFlagKey(
    "order-tracking-anomaly-detection-hours",
  ), // Number of hours to look back for order tracking anomaly detection (non-confirmation triggers)
  ORDER_CONFIRMATION_ANOMALY_DETECTION_HOURS: featureFlagKey(
    "order-confirmation-anomaly-detection-hours",
  ), // Number of hours to look back for order confirmation anomaly detection
  RELEASE_OT_RECIPIENT_SENDING: featureFlagKey("release-ot-recipient-sending"),
  SHORTENED_LINK_BASE_URL: featureFlagKey("shortened-link-base-url"), // Base URL for shortened marketing links (e.g., "https://redo.link")
  SHORTENED_LINK_CRDB_READ: featureFlagKey("shortened-link-crdb-read"), // Resolve redirects from CockroachDB before falling back to MongoDB. System-scoped kill switch; default OFF.
  MARKETING_SEGMENT_EMAIL_DOMAIN_FILTER: featureFlagKey(
    "marketing-segment-email-domain-filter",
  ), // Enable email address filtering in marketing segments
  SEGMENT_EMAIL_EXPORT: featureFlagKey("segment-email-export"), // Route the segments page Export action through the async file-download engine with email-only delivery
  DISCOUNT_UI: featureFlagKey("discount-ui"), // Show the beta Discounts UI in the merchant marketing navigation
  TIKTOK_ADS_INTEGRATION: featureFlagKey("tiktok-ads-integration"), // Gate the TikTok Ads audience-sync integration (connect + sync) in the merchant app
  OKENDO_MARKETING_INTEGRATION: featureFlagKey("okendo-marketing-integration"), // Show the Okendo marketing integration card on the integrations hub. Default OFF; ships dark while the loyalty/profile sync is built out.
  EMAIL_TABLE_BLOCK: featureFlagKey("email-table-block"), // Show the dynamic table block in the email builder's block picker. Targeted per team; default OFF until the block is ready for general rollout.
  OFFERS_TRACKING_PAGE_BLOCK: featureFlagKey("offers-tracking-page-block"), // Show the Offers block (Rokt/Falcon) in the tracking page builder. Per team; default OFF.
  TRACKING_PAGE_CUSTOM_HTML_SCRIPTS: featureFlagKey(
    "tracking-page-custom-html-scripts",
  ), // Allow Custom HTML blocks to run JavaScript on the live tracking page. Per team; default OFF.
  MARKETING_ATTRIBUTION_METRICS_CLICKHOUSE: featureFlagKey(
    "marketing-attribution-metrics-clickhouse",
  ), // Source campaign/automation revenue + orders from ClickHouse attribution, not Mongo. Per team; default OFF.
  MARKETING_ANALYTICS_CUSTOM_REPORTS: featureFlagKey(
    "marketing-analytics-custom-reports",
  ), // Show Custom Reports under Marketing Analytics. Default OFF.
  NOSTO_SERVER_SIDE_RECOMMENDATIONS: featureFlagKey(
    "nosto-server-side-recommendations",
  ), // Server-side Nosto rec injection into custom HTML for teams with settings.nostoRecommendations. Default OFF.
  MALOMO_POSTSCRIPT_API_VERSION: featureFlagKey(
    "malomo-postscript-api-version",
  ), // Malomo-source OT Postscript path: "v1" (default) | "shadow" | "v2". Retire after the Aug 14, 2026 v1 sunset.
  ORDER_DELIVERY_ESTIMATE_CRDB_READS: featureFlagKey(
    "order-delivery-estimate-crdb-reads",
  ), // Serve EDD pins from CRDB order_delivery_estimate, not Mongo. Dual-write stays on. Per team; default OFF.
} as const;
